import _ from 'lodash';

let cache = {};

export const storeData = (name, key, data) => {
    cache[name] = cache[name] || {};
    cache[name][key] = data;
    return key;
};

export const getData = (name, key, objectKey) => {
    if (_.isString(key) && cache[name] && cache[name][key]) {
        return cache[name][key];
    }
    if (objectKey && key[objectKey] && cache[name] && cache[name][key[objectKey]]) {
        cache[name][key[objectKey]] = key;
    }
    return key;
};